// src/stations/greenStations.js
export const GREEN_STATIONS = [
  {
    "station_id": "SLKI",
    "lat": 12.861702806559991,
    "lng": 77.52994685360525,
    "name": "Silk Institute",
    "name_kn": "ಸಿಲ್ಕ್ ಇನ್‌ಸ್ಟಿಟ್ಯೂಟ್",
    "name_hi": "सिल्क इंस्टिट्यूट",
  },
  {
    "station_id": "THAL",
    "lat": 12.871355881597905,
    "lng": 77.5383345088441,
    "name": "Thallaghattapura",
    "name_kn": "ತಾಳಘಟ್ಟಪುರ",
    "name_hi": "थालघट्टपुरा",
  },
  {
    "station_id": "VJHL",
    "lat": 12.877527277527701,
    "lng": 77.54480355767222,
    "name": "Vajrahalli",
    "name_kn": "ವಜ್ರಹಳ್ಳಿ",
    "name_hi": "वज्रहल्ली",
  },
  {
    "station_id": "DKSD",
    "lat": 12.884657367632204,
    "lng": 77.55276708643498,
    "name": "Doddakallasandra",
    "name_kn": "ದೊಡ್ಡಕಲ್ಲಸಂದ್ರ",
    "name_hi": "दोड्डकल्लसंद्र",
  },
  {
    "station_id": "KNKC",
    "lat": 12.888921195411202,
    "lng": 77.56276818941127,
    "name": "Konankunte Cross",
    "name_kn": "ಕೋಣನಕುಂಟೆ ಕ್ರಾಸ್",
    "name_hi": "कोननकुंटे क्रॉस",
  },
  {
    "station_id": "YLCN",
    "lat": 12.896055212378673,
    "lng": 77.5701596275028,
    "name": "Yelachenahalli",
    "name_kn": "ಯೆಲಚೇನಹಳ್ಳಿ",
    "name_hi": "येलाचेनहल्लि",
  },
  {
    "station_id": "JPNG",
    "lat": 12.907557103204923,
    "lng": 77.57305949435961,
    "name": "Jaya Prakash Nagar",
    "name_kn": "ಜಯಪ್ರಕಾಶ್ ನಗರ",
    "name_hi": "जयप्रकाश नगर",
  },
  {
    "station_id": "BNKI",
    "lat": 12.915551230491378,
    "lng": 77.5736287694447,
    "name": "Banashankri",
    "name_kn": "ಬನಶಂಕರಿ",
    "name_hi": "बनशंकरी",
  },
  {
    "station_id": "RVRD",
    "lat": 12.921587848279543,
    "lng": 77.58025614168618,
    "name": "Rashtreeya Vidyalaya Road",
    "name_kn": "ರಾಷ್ಟ್ರೀಯ ವಿದ್ಯಾಲಯ ರಸ್ತೆ",
    "name_hi": "राष्ट्रीय विद्यालय रोड",
  },
  {
    "station_id": "JYNG",
    "lat": 12.92967422676989,
    "lng": 77.58016494644542,
    "name": "Jayanagar",
    "name_kn": "ಜಯನಗರ",
    "name_hi": "जयनगर",
  },
  {
    "station_id": "SEDC",
    "lat": 12.938336700358771,
    "lng": 77.58007678071478,
    "name": "South End Circle",
    "name_kn": "ಸೌತ್ ಎಂಡ್ ಸರ್ಕಲ್",
    "name_hi": "साउथ एंड सर्कल",
  },
  {
    "station_id": "LBGH",
    "lat": 12.94627640048704,
    "lng": 77.58006905226816,
    "name": "Lalbagh",
    "name_kn": "ಲಾಲ್‌ಬಾಗ್",
    "name_hi": "लालबाग",
  },
  {
    "station_id": "NTCL",
    "lat": 12.950610881779667,
    "lng": 77.57373422004481,
    "name": "National College",
    "name_kn": "ನ್ಯಾಷನಲ್ ಕಾಲೇಜು",
    "name_hi": "नेशनल कॉलेज",
  },
  {
    "station_id": "KRRM",
    "lat": 12.960164957652083,
    "lng": 77.57446595427264,
    "name": "Krishna Rajendra Market",
    "name_kn": "ಕೃಷ್ಣರಾಜೇಂದ್ರ ಮಾರುಕಟ್ಟೆ",
    "name_hi": "कृष्णराजेंद्र मार्केट",
  },
  {
    "station_id": "CKPT",
    "lat": 12.967565637770267,
    "lng": 77.57478190315432,
    "name": "Chickpete",
    "name_kn": "ಚಿಕ್‌ಪೇಟೆ",
    "name_hi": "चिकपेटे",
  },
  {
    "station_id": "MJST",
    "lat": 12.975703634102517,
    "lng": 77.57284174633583,
    "name": "Majestic",
    "name_kn": "ಮಜೆಸ್ಟಿಕ್",
    "name_hi": "मजे़स्टिक",
  },
  {
    "station_id": "MNTS",
    "lat": 12.990564920636295,
    "lng": 77.57078756689127,
    "name": "Mantri Square",
    "name_kn": "ಮಂತ್ರೀ ಸ್ಕ್ವೇರ್",
    "name_hi": "मंत्री स्क्वायर",
  },
  {
    "station_id": "SRPR",
    "lat": 12.996519104095086,
    "lng": 77.56336431863538,
    "name": "Srirampura",
    "name_kn": "ಶ್ರೀರಾಮಪುರ",
    "name_hi": "श्रीरामपुरा",
  },
  {
    "station_id": "MKVR",
    "lat": 12.998503180866594,
    "lng": 77.5569625487527,
    "name": "Mahakavi Kuvempu Road",
    "name_kn": "ಮಹಾಕವಿ ಕುವೆಂಪು ರಸ್ತೆ",
    "name_hi": "महाकवि कुवेम्पु रोड",
  },
  {
    "station_id": "RJN",
    "lat": 13.000351483962074,
    "lng": 77.54974766598565,
    "name": "Rajajinagar",
    "name_kn": "ರಾಜಾಜಿನಗರ",
    "name_hi": "राजाजीनगर",
  },
  {
    "station_id": "MHLX",
    "lat": 13.008332895001459,
    "lng": 77.54883464564503,
    "name": "Mahalakshmi",
    "name_kn": "ಮಹಾಲಕ್ಷ್ಮಿ",
    "name_hi": "महालक्ष्मी",
  },
  {
    "station_id": "SSFC",
    "lat": 13.014731993011381,
    "lng": 77.55403598375526,
    "name": "Sandal Soap Factory",
    "name_kn": "ಸ್ಯಾಂಡಲ್ ಸೋಪ್ ಫ್ಯಾಕ್ಟರಿ",
    "name_hi": "सैंडल सोप फैक्टरी",
  },
  {
    "station_id": "YSHP",
    "lat": 13.023317224652427,
    "lng": 77.54987056155004,
    "name": "Yeshwantpur",
    "name_kn": "ಯಶವಂತಪುರ",
    "name_hi": "यशवंतपुर",
  },
  {
    "station_id": "GRGP",
    "lat": 13.028483584734099,
    "lng": 77.54087239288452,
    "name": "Goragunte Palya",
    "name_kn": "ಗೊರಗುಂಟೆ ಪಾಳ್ಯ",
    "name_hi": "गोरगुंटे पालय",
  },
  {
    "station_id": "PNYA",
    "lat": 13.032993913072373,
    "lng": 77.53347378828832,
    "name": "Peenya",
    "name_kn": "ಪೀನ್ಯ",
    "name_hi": "पीन्या",
  },
  {
    "station_id": "PNYD",
    "lat": 13.036447065413412,
    "lng": 77.52544967875858,
    "name": "Peenya Industry",
    "name_kn": "ಪೀನ್ಯ ಇಂಡಸ್ಟ್ರಿ",
    "name_hi": "पीन्या इंडस्ट्री",
  },
  {
    "station_id": "JLHL",
    "lat": 13.039661345202138,
    "lng": 77.51981822231163,
    "name": "Jalahalli",
    "name_kn": "ಜಲಹಳ್ಳಿ",
    "name_hi": "जलहल्लि",
  },
  {
    "station_id": "DSRH",
    "lat": 13.043522706930732,
    "lng": 77.51237402283587,
    "name": "Dasarahalli",
    "name_kn": "ದಾಸರಹಳ್ಳಿ",
    "name_hi": "दासरहल्लि",
  },
  {
    "station_id": "NGSD",
    "lat": 13.04812681873809,
    "lng": 77.50010321204078,
    "name": "Nagasandra",
    "name_kn": "ನಾಗಸಂದ್ರ",
    "name_hi": "नागसंद्रा",
  },
  {
    "station_id": "MJNR",
    "lat": 13.050197014639513,
    "lng": 77.49430565891258,
    "name": "Manjunath Nagar",
    "name_kn": "ಮಂಜುನಾಥ ನಗರ",
    "name_hi": "मंजुनाथ नगर",
  },
  {
    "station_id": "CKBD",
    "lat": 13.052395398561535,
    "lng": 77.48790578774167,
    "name": "Chikkabidarakallu",
    "name_kn": "ಚಿಕ್ಕಬಿದರಕಲ್ಲು",
    "name_hi": "चिक्कबिदरकल्लु",
  },
  {
    "station_id": "MDVR",
    "lat": 13.057405713818026,
    "lng": 77.47290241351799,
    "name": "Madavara",
    "name_kn": "ಮಾದವರ",
    "name_hi": "मादवर",
  },
];
